export interface FormMetadata {
  AddNewEditButtons: boolean;
  AdditionalFields: number;
  AllowAddNew: boolean;
  AllowDelete: boolean;
  AutomaticDataAccess: boolean;
  BIDataSource: boolean;
  Button1: number;
  Button2: number;
  Button3: number;
  Button4: number;
  CustomReport: boolean;
  ExtendedFlag: false;
  FormCaption: number;
  InsaDBType: number;
  InsaFormType: number;
  MetaDataName: string;
  RegisterConnection: boolean;
  ReportNumber: number;
  ResizeFlag: boolean;
  Source: string;
  SourceIsSP: boolean;
  UnderlyingKeyID: string;
  Layout?: string;
  ControlsRenderingDirection?: 'horizontal' | 'vertical';
  MaxNumberOfColsRows?: number;
  AllowEdit?: boolean;
}

export interface FieldMetadataDetail {
  AdditionalField: string;
  BaseTable: string;
  Changed: boolean;
  Confidential: boolean;
  DataType: string;
  DefaultValue: string;
  DefaultVisibility: any;
  FieldName: string;
  FieldTag: string;
  FieldWidth: number;
  FilterAdditionalField: any;
  Format: string;
  GroupEnabled: boolean;
  ImageDisplayField: any;
  InitValue: string;
  IsIdentity: boolean;
  IsKey: boolean;
  Locked: boolean;
  LookupDisplayField: string;
  LookupField: string;
  LookupTable: string;
  MaxInputWidth: number;
  MaxLength: number;
  MetaDataName: string;
  OrderID: number;
  ReportFieldID: number;
  ShowTotals: boolean;
  SortAdditionalField: any;
  SortEnabled: boolean;
  SourceField: string;
  VisibleOnGrid: null;
  WordWrap: boolean;
  EditingFieldName?: string;
  RenderingGroupName?: string;
  PrefixColumns?: string;
}

export interface ParsedFieldMetadataDetail extends FieldMetadataDetail {
  FieldTitle?: string;
  JavascriptType?: 'string' | 'number' | 'boolean' | 'date';
}

export interface InsaMetadataFormGroups {
  GroupName?: string;
  GroupDescription?: string;
  ControlsRenderingDirection?: 'horizontal' | 'vertical';
  MaxNumberOfColsRows?: number;
  VisibilityExpression?: string;
  FieldTag?: string;
}

export type RecordSet = any[];

export type LookupEntityList = {
  MetadataFieldname: string;
  lookupData: any[];
  lookupTableName: string;
  lookupDisplayField: string;
  lookupField: string;
}[];

export interface MetadataEntity { InsaMetaData: [FormMetadata]; InsaMetaDataDetails: FieldMetadataDetail[], InsaMetadataFormGroups?: InsaMetadataFormGroups[] };
export interface GenericDataEntity { MetaDataLookupEntity: LookupEntityList; MetaDataSelectedEntity: any[] }

interface ParsedMetadataEntity { InsaMetaData: [FormMetadata]; InsaMetaDataDetails: ParsedFieldMetadataDetail[], InsaMetadataFormGroups?: InsaMetadataFormGroups[] };

export type MetadataSet = [
  MetadataEntity,
  GenericDataEntity
];

export type ParsedMetadataSet = [
  ParsedMetadataEntity,
  GenericDataEntity
];



// WEBPACK FOOTER //
// ./app/insa-models/meta-data.model.ts